import { Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
  alertItem,
  bubble,
  icon,
  text as textRecipe,
  wrappedIcon,
} from '@mage-ui/styled-system/recipes';
import { forwardRef } from 'react';

export const AlertItem = forwardRef(({ text, ...props }, ref) => {
  return (
    <div ref={ref} className={alertItem().root} {...props}>
      <div className={cx(wrappedIcon(), bubble({ size: 'm' }))}>
        <Icon name='alert' classNames={icon({ size: 'm' })} />
      </div>
      <span
        className={cx(
          textRecipe({ size: '2', weight: 'semiBold' }),
          alertItem().text,
        )}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
});
